import { IconType } from "../icon-props";

const Previous: IconType = (
  <>
    <path d="M8.66666 24.516C9.04443 24.516 9.36088 24.3878 9.61599 24.1314C9.87199 23.8758 9.99999 23.5588 9.99999 23.1804V9.82393C9.99999 9.44549 9.87199 9.12806 9.61599 8.87161C9.36088 8.61606 9.04443 8.48828 8.66666 8.48828C8.28888 8.48828 7.97243 8.61606 7.71732 8.87161C7.46132 9.12806 7.33332 9.44549 7.33332 9.82393V23.1804C7.33332 23.5588 7.46132 23.8758 7.71732 24.1314C7.97243 24.3878 8.28888 24.516 8.66666 24.516ZM22.6 23.147C23.0444 23.4586 23.5 23.4809 23.9667 23.2138C24.4333 22.9467 24.6667 22.546 24.6667 22.0117V10.9926C24.6667 10.4584 24.4333 10.063 23.9667 9.80656C23.5 9.55101 23.0444 9.56793 22.6 9.85732L14.3333 15.4003C13.9333 15.6674 13.7333 16.0347 13.7333 16.5022C13.7333 16.9696 13.9333 17.3369 14.3333 17.6041L22.6 23.147Z" />
  </>
);

export default Previous;
